import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { translationsMap } from './languageMap.js';

/**
 * Copyright 2025, IntraLinks, Inc. All rights reserved.
 */
var ENGLISH_LANGUAGE = 'en';
var locale = document.documentElement.lang || ENGLISH_LANGUAGE;

// eslint-disable-next-line import/no-mutable-exports
var i18nInstance;

// Converts translationsMap into the format required by i18next,
// where each language key is mapped to an object with a "translation" property.
// Ex: { en: { translation: { pagination: { backwardText: "Previous page" }, searchPlaceholder: "Search..." }}}
var translations = Object.keys(translationsMap).reduce(function (acc, lang) {
  acc[lang] = {
    translation: translationsMap[lang]
  };
  return acc;
}, {});
var getI18nInstance = function getI18nInstance() {
  if (!i18nInstance) {
    i18nInstance = i18next.createInstance().use(LanguageDetector).createInstance({
      detection: {
        order: ['htmlTag',
        // looks for the html 'lang' attribute
        'localStorage' // looks for the value of the 'i18nextLng' key from localStorage
        ]
      },
      resources: translations,
      fallbackLng: ENGLISH_LANGUAGE,
      lng: locale,
      load: 'all',
      ns: ['translation'],
      defaultNS: 'translation',
      interpolation: {
        escapeValue: false
      },
      react: {
        transEmptyNodeValue: '',
        wait: true,
        useSuspense: false,
        transSupportBasicHtmlNodes: false
      }
    }, function () {
      // this empty block is added so the init is run automatically on this instance. This way we avoid to do it async.
    });
  }
  return i18nInstance;
};

export { getI18nInstance };
